import { useNavigate } from "react-router-dom";
import Industrial from "../assets/images/Industrial.jpg";
import Enterprise from "../assets/images/Meeting.jpg";
import Flexible from "../assets/images/Shared-space.jpg";
import StoreFront from "../assets/images/StoreFront.jpg";
import "../App.css";
import "./AboutUsPage.css";

function SolutionsPage() {
  const navigate = useNavigate();
  const solutions = [
    {
      title: "Flexible/Shared Workspaces",
      description:
        "Ready-to-move-in offices with flexible terms to suit your business needs.",
      hoverDescription:
        "Perfect for freelancers, startups, and teams looking for short-term or flexible arrangements.",
      image: Flexible,
    },
    {
      title: "Enterprise Solutions",
      description:
        "Custom workplace solutions designed for large organizations.",
      hoverDescription:
        "Tailored spaces for corporations with dedicated floors, custom designs, and enterprise-grade amenities.",
      image: Enterprise,
    },
    {
      title: "Stores & Studios",
      description:
        "Retail and studio spaces designed for creativity and collaboration.",
      hoverDescription:
        "Ideal for artists, retailers, and creatives needing specialized spaces with high visibility.",
      image: StoreFront,
    },
    {
      title: "Industrial Workspaces",
      description:
        "Industrial spaces designed for manufacturing and logistics.",
      hoverDescription:
        "Spacious facilities with loading docks, high ceilings, and infrastructure for industrial operations.",
      image: Industrial,
    },
  ];

  const handleContactSales = () => {
    navigate("/contactUs");
  };

  const handleBrowseLocations = () => {
    navigate("/");
  };

  return (
    <div className="font-serif text-gray-900 px-12">
      {/* Hero Section */}
      <section className="relative ">
        <div className="container ">
          <h1 className="text-4xl md:text-5xl mb-10">
            Solutions for all workspaces
          </h1>
          <p className="text-xl md:text-2xl max-w-6xl ">
            AirArrange provides flexible workspace solutions to help businesses
            of all types and sizes thrive.
          </p>
        </div>
      </section>

      {/* Solutions Grid - Updated with hover effect */}
      <section className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="group block rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-64 md:h-80">
                {/* Image with hover darkening effect */}
                <div className="relative h-full w-full overflow-hidden">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover transition-all duration-300 group-hover:scale-105 group-hover:brightness-75"
                  />
                  {/* Text overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent flex flex-col justify-end p-6">
                    <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 group-hover:opacity-0">
                      {solution.title}
                    </h2>
                    <p className="text-lg text-white/90 transition-opacity duration-300 group-hover:opacity-0">
                      {solution.description}
                    </p>
                    <p className="text-lg text-white/90 absolute opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {solution.hoverDescription}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-medium mb-6">
            Ready to find your workspace?
          </h2>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button onClick={handleContactSales} className="secondary-button">
              Contact Sales
            </button>
            <button
              onClick={handleBrowseLocations}
              className="secondary-button"
            >
              Browse Locations
            </button>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="container mx-auto px-6 py-20">
        <h2 className="text-3xl font-bold text-center mb-12">
          Why businesses choose AirArrange
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              quote:
                "AirArrange gave us the flexibility we needed to scale quickly.",
              author: "Sarah Johnson, CTO of TechStart",
            },
            {
              quote:
                "Our team loves the collaborative environment at AirArrange.",
              author: "Michael Chen, CEO of DesignCo",
            },
            {
              quote:
                "The global network helped us expand internationally with ease.",
              author: "Emma Rodriguez, Director of GlobalOps",
            },
          ].map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md">
              <p className="text-lg italic mb-4">"{testimonial.quote}"</p>
              <p className="font-semibold">— {testimonial.author}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default SolutionsPage;
